<template>
  <div class="container mt-4">
    <h3>Editar temática</h3>
    <div v-if="loading" class="d-flex justify-content-center align-items-center" style="height: 200px;">
        <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Cargando...</span>
        </div>
    </div>
    <form @submit="update">
      <div class="form-group mb-3">
        <label class="form-label">Nombre</label>
        <input type="text" class="form-control" v-model="topic.name" />
      </div>
      <div class="form-group mb-3">
        <label class="form-label">Descripción</label>
        <input type="text" class="form-control" v-model="topic.description" />
      </div>
      <div class="form-group mb-3">
        <label class="form-label">Imagen</label>
        <input
          type="file"
          class="form-control"
          @change="uploadImage"
          accept="image/*"
        />
      </div>
      <div class="form-group mb-3">
        <label class="form-label">Color</label>
        <input type="text" class="form-control" v-model="topic.color" />
      </div>
      <div class="form-group mb-3 d-flex align-items-center">
        <label for="enabledSwitch" class="form-label me-3 mb-0" style="min-width: 100px;">Activar</label>
        <div class="form-check form-switch m-0">
            <input
            class="form-check-input"
            type="checkbox"
            role="switch"
            id="enabledSwitch"
            v-model="topic.enabled"
            />
        </div>
      </div>

      <div class="d-flex justify-content-end gap-2 mb-4">
        <router-link class="btn btn-secondary" :to="{ path: '/app/blog', query: { tab: 'topics' } }">
            Volver
        </router-link>
        <button :id="'submitBtn'" type="submit" class="btn btn-primary">
            Guardar
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import TopicService from "@/services/topic.service";
import Swal from "sweetalert2";

export default {
  name: "EditTopicView",
  data() {
    return {
      uuid: this.$route.params.uuid,
      topic: {
        name: "",
        description: "",
        color: "",
        enabled: true,
      },
      image: null,
      loading: true,
    };
  },
  async created() {
    await this.fetchTopic();
  },
  methods: {
    async fetchTopic() {
      try {
        this.loading = true;
        const response = await TopicService.getTopic(this.uuid);
        if (response && response.data && response.data.topic) {
          this.topic.name = response.data.topic.name;
          this.topic.description = response.data.topic.description;
          this.topic.color = response.data.topic.color;
          this.topic.enabled = response.data.topic.enabled;
        }
      } catch (error) {
        console.error("Error loading topic:", error);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "No se pudo cargar la temática",
        });
      } finally {
        this.loading = false;
      }
    },
    uploadImage(event) {
      this.image = event.target.files[0];
    },
    async update(evt) {
      evt.preventDefault();
      const btn = document.getElementById("submitBtn");
      btn.innerHTML =
        '<span class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>Guardando';

      const fd = new FormData();
      if (this.image) {
        fd.append("image", this.image);
      }
      fd.append("name", this.topic.name);
      fd.append("description", this.topic.description);
      fd.append("color", this.topic.color);
      fd.append("enabled", this.topic.enabled.toString());

      try {
        const response = await TopicService.updateTopic(this.uuid, fd);
        btn.innerHTML = "Guardar";
        if (response.status === 200) {
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Se ha guardado correctamente.",
            showConfirmButton: false,
            timer: 1500,
            backdrop: false,
            toast: true,
          });
          this.$router.push({ path: "/app/blog", query: { tab: "topics" } });
        }
      } catch (error) {
        console.error("Error updating topic:", error);
        btn.innerHTML = "Guardar";
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "No se pudo guardar la temática",
        });
      }
    },
  },
};
</script>
